import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'login',
		component: Login
	},
	{
		path: '/products',
		name: 'products',
		component: () => import('../views/Products.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/direct-purchase',
		name: 'direct-purchase',
		component: () => import('../views/DirectPurchase.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/direct-purchase/export',
		name: 'exportDP',
		component: () => import('../views/ExportDirectPurchase.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/direct-purchase/import',
		name: 'direct-purchase-import',
		component: () => import('../views/Direct_Purchase__CSV_Import.vue'),
		meta: {
			auth: true
		}
	},

	{
		path: '/direct-purchase/:id',
		name: 'direct-purchase-view',
		component: () => import('../views/DPView.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/add-direct-purchase',
		name: 'add-direct-purchase',
		component: () => import('../views/AddDirectPurchase.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/po/:page?',
		name: 'po',
		component: () => import('../views/PO.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/po/detail/:id',
		name: 'poDetail',
		component: () => import('../views/POView.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/pi',
		name: 'pi',
		component: () => import('../views/PI.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/pi/detail/:id/:brand',
		name: 'piDetail',
		component: () => import('../views/PIView.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/pi/view/:id',
		name: 'createPi',
		component: () => import('../views/AddPurchaseInvoice.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/returns',
		name: 'returns',
		component: () => import('../views/Returns.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/returns/view/:id',
		name: 'returnsDetails',
		component: () => import('../views/ReturnsDetails.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/products/export',
		name: 'exportProducts',
		component: () => import('../views/ExportProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/po',
		name: 'exportPO',
		component: () => import('../views/ExportPO.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/pi',
		name: 'exportPI',
		component: () => import('../views/ExportPI.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/product-transfer',
		name: 'productTransferList',
		component: () => import('../views/WarehouseTransfer.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/transfer/create',
		name: 'productTransfer',
		component: () => import('../views/WarehouseTransfer__Create.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/transfer/import',
		name: 'productTransferImport',
		component: () => import('../views/WarehouseTransfer__CSV_Import.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/transfer/export',
		name: 'exportWarehouseTransfer',
		component: () => import('../views/WarehouseTransfer__Export.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/transfer/detail/:id',
		name: 'transferDetail',
		component: () => import('../views/WarehouseTransfer__Detail.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/stock-transfer',
		name: 'transferStockList',
		component: () => import('../views/Warehouse_Stock_Transfer__list.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/stock-transfer/create',
		name: 'transferStockCreate',
		component: () => import('../views/Warehouse_Stock_Transfer__create.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/stock-transfer/export',
		name: 'transferStockCreate',
		component: () => import('../views/Warehouse_Stock_Transfer__Export.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse/stock-transfer/detail/:id',
		name: 'transferStockDetail',
		component: () => import('../views/Warehouse_Stock_Transfer__detail.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/returns/export',
		name: 'exportReturns',
		component: () => import('../views/ExportReturns.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout
	}
]

const router = new VueRouter({
	routes
})

export default router
